import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TabBar from '@lib/components/TabBar/TabBar';
import { TabBarItem as TabBarItemType } from '@lib/components/TabBar/constants';
import getTabs from 'components/TaskMenuBar/utils/getTabs';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';
import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';

interface Props {
  id?: string;
}

function TaskMenuBar({ id }: Props) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { getUserAccessByComponent, getUserAccessByCompany }: ContextProps =
    useOutletContext();
  const isInterventionsLocked =
    getUserAccessByCompany(AccessComponentEnum.InterventionsManagement) ===
      AccessLevelEnum.LimitedRead ||
    getUserAccessByComponent(AccessComponentEnum.InterventionsManagement) ===
      AccessLevelEnum.LimitedRead;
  const tabs = getTabs({ isInterventionsLocked, t, id });
  const onActiveChange = ({ value }: TabBarItemType) => {
    navigate(value);
  };
  return (
    <TabBar
      items={tabs}
      active={pathname}
      onActiveChange={onActiveChange}
      useSidePaddings
      bleedSidePaddings
    />
  );
}

export default TaskMenuBar;
